//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ShowHover",
  component: {},
  data() {
    return {
      showHover: false
    };
  },
   props: {
    url:String,
    invoke: Function,
    model:Object
  },
  methods: {
    initData(){
        this.invoke('invokeCustomEvent',{type: 'init_data'})
    },

  },
  created() {
    this.initData()
  },
};
